import { ReactElement, useState } from 'react';
import PropTypes from 'prop-types';
import FieldWrapper from '../FieldWrapper';
import { Field } from 'formik';
import { LABEL_POSITIONS } from '../_constants';

/**
 * DatePicker input which is Formik-compliant
 * @param {*} properties needed by DatePicker including but not limited to name, label, errorMessage and error
 * @returns {ReactElement} DatePicker Field component
 */
const DatePicker = ({ ...props }) => {
	const {
		label,
		errorMessage,
		error: hideErrorMessage,
		formDetails,
		handleChange,
	} = props;
	const [selectedDate, setSelectedDate] = useState(formDetails.value);

	const handleOnChange = e => {
		setSelectedDate(e.target.value);
		handleChange(
			{ target: { value: e.target.value } },
			formDetails.entryKey
		);
	};

	return (
		<FieldWrapper
			name={props.name}
			label={label}
			meta={{
				touched: hideErrorMessage,
				error: errorMessage,
			}}
			hideErrorMessage={!hideErrorMessage}
			additionalProps={{
				labelPosition: LABEL_POSITIONS.LEFT,
			}}
		>
			<Field
				type={'date'}
				name={props.name}
				value={selectedDate}
				onChange={handleOnChange}
				autoComplete={'off'}
			/>
		</FieldWrapper>
	);
};

DatePicker.propTypes = {
	type: PropTypes.string,
	name: PropTypes.string,
	className: PropTypes.string,
	label: PropTypes.string,
	errorMessage: PropTypes.string,
	error: PropTypes.bool,
	handleChange: PropTypes.func,
	formDetails: PropTypes.shape({
		value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	}),
};

export default DatePicker;
